var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppStoreQrcode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 275,
    viewBox: "0 0 213 275",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.67 274.3H16.339C12.6829 274.3 9.72577 271.415 9.72577 267.848V226.161C9.72577 222.593 12.6919 219.708 16.339 219.708H196.67C200.326 219.708 203.283 222.602 203.283 226.161V267.839C203.283 271.406 200.317 274.3 196.67 274.3Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.67 275H16.339C12.2887 275 9 271.791 9 267.839V226.161C9 222.209 12.2887 219 16.339 219H196.67C200.72 219 204.009 222.209 204.009 226.161V267.839C204 271.791 200.711 275 196.67 275ZM16.339 220.416C13.0862 220.416 10.4517 222.996 10.4517 226.161V267.839C10.4517 271.013 13.0952 273.584 16.339 273.584H196.67C199.923 273.584 202.557 271.004 202.557 267.839V226.161C202.557 222.987 199.914 220.416 196.67 220.416H16.339Z",
    fill: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9224 234.921L73.1069 237.527H71.3326L74.3525 228.329H76.5479L79.6126 237.536H77.7666L76.9153 234.93H73.9224V234.921ZM76.6196 233.654L75.8759 231.389C75.6966 230.83 75.5443 230.2 75.4009 229.667H75.374C75.2307 230.2 75.0963 230.838 74.926 231.389L74.2002 233.654H76.6196Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1844 230.882L83.2866 234.257C83.4837 234.843 83.6182 235.376 83.7526 235.918H83.7974C83.9228 235.376 84.0752 234.851 84.2633 234.257L85.3566 230.882H87.1577L84.5591 237.527H82.8654L80.3295 230.882H82.1844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0217 235.935C94.0217 236.539 94.0486 237.125 94.1382 237.535H92.588L92.4625 236.801H92.4177C92.0145 237.317 91.2976 237.684 90.4015 237.684C89.0305 237.684 88.2598 236.714 88.2598 235.708C88.2598 234.047 89.7832 233.181 92.3012 233.199V233.085C92.3012 232.648 92.122 231.922 90.9123 231.922C90.2402 231.922 89.5413 232.123 89.0842 232.412L88.7527 231.319C89.2545 231.022 90.1416 230.733 91.217 230.733C93.4034 230.733 94.0307 232.088 94.0307 233.549V235.935H94.0217ZM92.3371 234.283C91.1184 234.266 89.9624 234.519 89.9624 235.525C89.9624 236.18 90.3925 236.478 90.9392 236.478C91.6381 236.478 92.131 236.04 92.2923 235.56C92.3371 235.446 92.3371 235.323 92.3371 235.201V234.283Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3016 229.929C96.7281 229.929 96.3517 229.518 96.3517 229.028C96.3517 228.513 96.746 228.11 97.3195 228.11C97.911 228.11 98.2694 228.504 98.2873 229.028C98.2873 229.518 97.911 229.929 97.3195 229.929H97.3016ZM96.4503 237.535V230.891H98.1708V237.535H96.4503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.644 227.831H102.365V237.535H100.644V227.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.143 235.935C110.143 236.539 110.169 237.125 110.25 237.535H108.7L108.574 236.801H108.53C108.126 237.317 107.409 237.684 106.513 237.684C105.142 237.684 104.372 236.714 104.372 235.708C104.372 234.047 105.895 233.181 108.413 233.199V233.085C108.413 232.648 108.234 231.922 107.033 231.922C106.361 231.922 105.662 232.123 105.205 232.412L104.874 231.319C105.375 231.022 106.262 230.733 107.338 230.733C109.515 230.733 110.152 232.088 110.152 233.549V235.935H110.143ZM108.458 234.283C107.239 234.266 106.083 234.519 106.083 235.525C106.083 236.18 106.513 236.478 107.06 236.478C107.759 236.478 108.252 236.04 108.413 235.56C108.458 235.437 108.458 235.315 108.458 235.192V234.283Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.571 227.831H114.292V231.8H114.318C114.74 231.162 115.483 230.733 116.505 230.733C118.172 230.733 119.355 232.088 119.346 234.108C119.346 236.495 117.795 237.684 116.254 237.684C115.376 237.684 114.587 237.352 114.103 236.539H114.076L113.996 237.535H112.526C112.553 237.081 112.58 236.346 112.58 235.682V227.831H112.571ZM114.292 234.79C114.292 234.93 114.309 235.061 114.336 235.184C114.516 235.866 115.116 236.355 115.86 236.355C116.935 236.355 117.598 235.525 117.598 234.169C117.598 232.998 117.025 232.045 115.878 232.045C115.179 232.045 114.534 232.534 114.354 233.269C114.327 233.391 114.301 233.54 114.301 233.706V234.79H114.292Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.371 227.831H123.091V237.535H121.371V227.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.792 234.676C126.837 235.874 127.796 236.399 128.889 236.399C129.687 236.399 130.242 236.276 130.78 236.102L131.031 237.247C130.439 237.492 129.633 237.667 128.656 237.667C126.443 237.667 125.143 236.346 125.143 234.309C125.143 232.464 126.29 230.733 128.477 230.733C130.69 230.733 131.416 232.508 131.416 233.968C131.416 234.283 131.389 234.528 131.362 234.676H126.792ZM129.785 233.505C129.803 232.893 129.516 231.879 128.369 231.879C127.303 231.879 126.855 232.823 126.792 233.505H129.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.902 237.684C137.985 237.684 136.488 236.399 136.488 234.257C136.488 232.071 137.958 230.733 140.01 230.733C142.035 230.733 143.397 232.123 143.397 234.143C143.397 236.582 141.632 237.675 139.911 237.675H139.902V237.684ZM139.956 236.469C140.933 236.469 141.623 235.542 141.623 234.187C141.623 233.146 141.148 231.949 139.974 231.949C138.755 231.949 138.262 233.111 138.262 234.213C138.262 235.498 138.916 236.469 139.938 236.469H139.956Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.422 232.867C145.422 232.106 145.395 231.459 145.368 230.891H146.865L146.945 231.887H146.99C147.295 231.372 148.039 230.742 149.177 230.742C150.368 230.742 151.596 231.494 151.596 233.592V237.536H149.876V233.776C149.876 232.823 149.508 232.097 148.576 232.097C147.895 232.097 147.42 232.578 147.232 233.076C147.178 233.216 147.151 233.417 147.151 233.61V237.527H145.431V232.867H145.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.518 229.177V230.882H161.158V232.141H159.518V235.061C159.518 235.883 159.742 236.285 160.396 236.285C160.701 236.285 160.871 236.268 161.068 236.215L161.095 237.483C160.844 237.579 160.378 237.658 159.849 237.658C159.204 237.658 158.693 237.457 158.371 237.116C157.994 236.731 157.824 236.119 157.824 235.245V232.132H156.856V230.873H157.824V229.632L159.518 229.177Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.066 227.831H164.787V231.791H164.814C165.02 231.476 165.316 231.214 165.665 231.039C166.015 230.847 166.418 230.742 166.857 230.742C168.013 230.742 169.231 231.494 169.231 233.619V237.535H167.511V233.793C167.511 232.84 167.144 232.097 166.194 232.097C165.522 232.097 165.047 232.534 164.85 233.041C164.796 233.19 164.778 233.374 164.778 233.549V237.535H163.057V227.831H163.066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.896 234.676C172.941 235.874 173.9 236.399 174.993 236.399C175.791 236.399 176.346 236.276 176.884 236.102L177.135 237.247C176.544 237.492 175.737 237.667 174.76 237.667C172.547 237.667 171.248 236.346 171.248 234.309C171.248 232.464 172.395 230.733 174.581 230.733C176.795 230.733 177.52 232.508 177.52 233.968C177.52 234.283 177.493 234.528 177.467 234.676H172.896ZM175.889 233.505C175.907 232.893 175.621 231.879 174.474 231.879C173.407 231.879 172.959 232.823 172.896 233.505H175.889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5235 246.454C52.4787 241.898 56.3409 239.686 56.5201 239.582C54.3336 236.469 50.9374 236.041 49.7456 236.006C46.896 235.717 44.136 237.667 42.6844 237.667C41.2058 237.667 38.9655 236.032 36.564 236.076C33.4635 236.128 30.5691 237.877 28.974 240.587C25.6943 246.13 28.1407 254.27 31.286 258.755C32.8631 260.95 34.7001 263.398 37.1017 263.31C39.4494 263.214 40.3276 261.85 43.1682 261.85C45.982 261.85 46.8064 263.31 49.2617 263.258C51.7887 263.214 53.3748 261.055 54.8892 258.843C56.7083 256.325 57.4341 253.85 57.47 253.728C57.4073 253.719 52.5683 251.909 52.5235 246.454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8817 233.068C49.1452 231.52 50.0144 229.422 49.7724 227.289C47.9444 227.367 45.6504 228.521 44.3331 230.034C43.1682 231.363 42.1198 233.549 42.3886 235.595C44.4586 235.752 46.5644 234.589 47.8817 233.068Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5216 262.961H83.2419L81.4497 257.452H75.2128L73.5013 262.961H70.3112L76.4942 244.215H80.3116L86.5216 262.961ZM80.912 255.144L79.2901 250.248C79.1198 249.75 78.7972 248.569 78.3223 246.716H78.2685C78.0803 247.512 77.7757 248.692 77.3545 250.248L75.7594 255.144H80.912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.427 256.036C102.427 258.336 101.791 260.154 100.519 261.483C99.3806 262.672 97.9647 263.258 96.2711 263.258C94.4431 263.258 93.1348 262.62 92.3372 261.343H92.2835V268.46H89.2009V253.894C89.2009 252.451 89.1651 250.965 89.0844 249.444H91.7906L91.9609 251.586H92.0236C93.0452 249.968 94.6044 249.164 96.6923 249.164C98.3232 249.164 99.6942 249.793 100.778 251.052C101.881 252.329 102.427 253.981 102.427 256.036ZM99.291 256.15C99.291 254.838 98.9863 253.745 98.3769 252.897C97.7138 252.005 96.8177 251.56 95.6976 251.56C94.9359 251.56 94.2459 251.804 93.6276 252.294C93.0093 252.792 92.6061 253.431 92.4179 254.226C92.3193 254.593 92.2745 254.899 92.2745 255.144V257.4C92.2745 258.379 92.5792 259.21 93.1975 259.883C93.8158 260.565 94.6223 260.897 95.608 260.897C96.764 260.897 97.669 260.469 98.3142 259.595C98.9684 258.729 99.291 257.575 99.291 256.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.36 256.036C118.36 258.336 117.724 260.154 116.451 261.483C115.313 262.672 113.897 263.258 112.204 263.258C110.385 263.258 109.067 262.62 108.27 261.343H108.216V268.46H105.142V253.894C105.142 252.451 105.107 250.965 105.026 249.444H107.732L107.902 251.586H107.965C108.987 249.968 110.546 249.164 112.634 249.164C114.265 249.164 115.627 249.793 116.72 251.052C117.813 252.329 118.36 253.981 118.36 256.036ZM115.224 256.15C115.224 254.838 114.919 253.745 114.31 252.897C113.646 252.005 112.75 251.56 111.63 251.56C110.868 251.56 110.179 251.804 109.56 252.294C108.942 252.792 108.539 253.431 108.35 254.226C108.252 254.593 108.207 254.899 108.207 255.144V257.4C108.207 258.379 108.512 259.21 109.13 259.883C109.748 260.565 110.546 260.897 111.541 260.897C112.697 260.897 113.602 260.469 114.247 259.595C114.901 258.729 115.224 257.575 115.224 256.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.174 257.706C136.174 259.297 135.61 260.6 134.463 261.597C133.208 262.69 131.47 263.24 129.23 263.24C127.16 263.24 125.502 262.856 124.247 262.078L124.964 259.577C126.317 260.373 127.796 260.775 129.418 260.775C130.574 260.775 131.479 260.521 132.124 260.014C132.769 259.498 133.092 258.816 133.092 257.968C133.092 257.208 132.823 256.569 132.294 256.045C131.766 255.52 130.879 255.039 129.642 254.593C126.282 253.369 124.597 251.577 124.597 249.216C124.597 247.678 125.188 246.41 126.362 245.431C127.536 244.443 129.104 243.953 131.067 243.953C132.814 243.953 134.266 244.25 135.422 244.845L134.651 247.293C133.567 246.716 132.339 246.427 130.977 246.427C129.893 246.427 129.05 246.69 128.441 247.205C127.93 247.669 127.67 248.237 127.67 248.902C127.67 249.645 127.966 250.257 128.549 250.738C129.059 251.184 129.991 251.664 131.344 252.189C132.993 252.836 134.212 253.597 134.992 254.471C135.78 255.328 136.174 256.412 136.174 257.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.345 251.699H142.958V258.265C142.958 259.935 143.558 260.766 144.759 260.766C145.306 260.766 145.763 260.722 146.121 260.626L146.202 262.908C145.601 263.127 144.795 263.24 143.809 263.24C142.59 263.24 141.641 262.882 140.959 262.156C140.278 261.431 139.929 260.215 139.929 258.51V251.699H137.904V249.444H139.929V246.969L142.949 246.078V249.444H146.336V251.699H146.345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.65 256.097C161.65 258.178 161.041 259.883 159.831 261.212C158.559 262.585 156.865 263.267 154.76 263.267C152.725 263.267 151.103 262.611 149.903 261.291C148.693 259.979 148.093 258.318 148.093 256.316C148.093 254.218 148.711 252.504 149.956 251.175C151.202 249.837 152.878 249.173 154.984 249.173C157.018 249.173 158.649 249.828 159.885 251.149C161.068 252.425 161.65 254.078 161.65 256.097ZM158.46 256.193C158.46 254.952 158.183 253.877 157.636 252.985C156.991 251.909 156.068 251.367 154.876 251.367C153.639 251.367 152.698 251.909 152.053 252.985C151.498 253.877 151.229 254.961 151.229 256.246C151.229 257.487 151.498 258.563 152.053 259.455C152.716 260.53 153.648 261.072 154.849 261.072C156.023 261.072 156.946 260.521 157.609 259.428C158.174 258.519 158.46 257.435 158.46 256.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.651 252.093C171.346 252.04 171.024 252.014 170.683 252.014C169.599 252.014 168.766 252.416 168.174 253.212C167.663 253.92 167.404 254.803 167.404 255.879V262.969H164.33L164.357 253.71C164.357 252.154 164.321 250.738 164.24 249.453H166.92L167.036 252.04H167.117C167.439 251.149 167.959 250.432 168.658 249.898C169.339 249.418 170.083 249.173 170.88 249.173C171.167 249.173 171.418 249.19 171.651 249.225V252.093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.415 255.564C185.415 256.106 185.379 256.552 185.307 256.928H176.078C176.113 258.266 176.561 259.28 177.413 259.988C178.192 260.618 179.196 260.932 180.433 260.932C181.795 260.932 183.04 260.722 184.169 260.294L184.653 262.384C183.345 262.943 181.795 263.223 180.003 263.223C177.861 263.223 176.167 262.602 174.949 261.369C173.73 260.137 173.112 258.484 173.112 256.403C173.112 254.366 173.685 252.67 174.823 251.315C176.015 249.872 177.637 249.146 179.662 249.146C181.66 249.146 183.175 249.872 184.196 251.315C185.012 252.46 185.415 253.877 185.415 255.564ZM182.485 254.786C182.503 253.894 182.305 253.125 181.884 252.478C181.356 251.647 180.531 251.227 179.429 251.227C178.425 251.227 177.61 251.638 176.983 252.451C176.472 253.098 176.167 253.877 176.078 254.786H182.485Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M213 0H0V213H213V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.88 13.49H13.49V19.88H19.88V13.49Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.27 13.49H19.88V19.88H26.27V13.49Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.66 13.49H26.27V19.88H32.66V13.49Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.05 13.49H32.66V19.88H39.05V13.49Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.44 13.49H39.05V19.88H45.44V13.49Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.83 13.49H45.44V19.88H51.83V13.49Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.22 13.49H51.83V19.88H58.22V13.49Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83.78 13.49H77.39V19.88H83.78V13.49Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.17 13.49H83.78V19.88H90.17V13.49Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.56 13.49H90.17V19.88H96.56V13.49Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M102.95 13.49H96.56V19.88H102.95V13.49Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M122.12 13.49H115.73V19.88H122.12V13.49Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M128.51 13.49H122.12V19.88H128.51V13.49Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M134.9 13.49H128.51V19.88H134.9V13.49Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M141.29 13.49H134.9V19.88H141.29V13.49Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M160.46 13.49H154.07V19.88H160.46V13.49Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M166.85 13.49H160.46V19.88H166.85V13.49Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M173.24 13.49H166.85V19.88H173.24V13.49Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M179.63 13.49H173.24V19.88H179.63V13.49Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M186.02 13.49H179.63V19.88H186.02V13.49Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M192.41 13.49H186.02V19.88H192.41V13.49Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M198.8 13.49H192.41V19.88H198.8V13.49Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M19.88 19.88H13.49V26.27H19.88V19.88Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M58.22 19.88H51.83V26.27H58.22V19.88Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M71 19.88H64.61V26.27H71V19.88Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M77.39 19.88H71V26.27H77.39V19.88Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M96.56 19.88H90.17V26.27H96.56V19.88Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M109.34 19.88H102.95V26.27H109.34V19.88Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M115.73 19.88H109.34V26.27H115.73V19.88Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M122.12 19.88H115.73V26.27H122.12V19.88Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M128.51 19.88H122.12V26.27H128.51V19.88Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M147.68 19.88H141.29V26.27H147.68V19.88Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M160.46 19.88H154.07V26.27H160.46V19.88Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M198.8 19.88H192.41V26.27H198.8V19.88Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M19.88 26.27H13.49V32.66H19.88V26.27Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M32.66 26.27H26.27V32.66H32.66V26.27Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M39.05 26.27H32.66V32.66H39.05V26.27Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M45.44 26.27H39.05V32.66H45.44V26.27Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M58.22 26.27H51.83V32.66H58.22V26.27Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M77.39 26.27H71V32.66H77.39V26.27Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M83.78 26.27H77.39V32.66H83.78V26.27Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M90.17 26.27H83.78V32.66H90.17V26.27Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M109.34 26.27H102.95V32.66H109.34V26.27Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M115.73 26.27H109.34V32.66H115.73V26.27Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M147.68 26.27H141.29V32.66H147.68V26.27Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M160.46 26.27H154.07V32.66H160.46V26.27Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M173.24 26.27H166.85V32.66H173.24V26.27Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M179.63 26.27H173.24V32.66H179.63V26.27Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M186.02 26.27H179.63V32.66H186.02V26.27Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M198.8 26.27H192.41V32.66H198.8V26.27Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M19.88 32.66H13.49V39.05H19.88V32.66Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M32.66 32.66H26.27V39.05H32.66V32.66Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M39.05 32.66H32.66V39.05H39.05V32.66Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M45.44 32.66H39.05V39.05H45.44V32.66Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M58.22 32.66H51.83V39.05H58.22V32.66Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M71 32.66H64.61V39.05H71V32.66Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M77.39 32.66H71V39.05H77.39V32.66Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M102.95 32.66H96.56V39.05H102.95V32.66Z",
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M109.34 32.66H102.95V39.05H109.34V32.66Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M128.51 32.66H122.12V39.05H128.51V32.66Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M141.29 32.66H134.9V39.05H141.29V32.66Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M160.46 32.66H154.07V39.05H160.46V32.66Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M173.24 32.66H166.85V39.05H173.24V32.66Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M179.63 32.66H173.24V39.05H179.63V32.66Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M186.02 32.66H179.63V39.05H186.02V32.66Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M198.8 32.66H192.41V39.05H198.8V32.66Z",
    fill: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M19.88 39.05H13.49V45.44H19.88V39.05Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M32.66 39.05H26.27V45.44H32.66V39.05Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M39.05 39.05H32.66V45.44H39.05V39.05Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M45.44 39.05H39.05V45.44H45.44V39.05Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M58.22 39.05H51.83V45.44H58.22V39.05Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M90.17 39.05H83.78V45.44H90.17V39.05Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M96.56 39.05H90.17V45.44H96.56V39.05Z",
    fill: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M122.12 39.05H115.73V45.44H122.12V39.05Z",
    fill: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M128.51 39.05H122.12V45.44H128.51V39.05Z",
    fill: "black"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M134.9 39.05H128.51V45.44H134.9V39.05Z",
    fill: "black"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M141.29 39.05H134.9V45.44H141.29V39.05Z",
    fill: "black"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M147.68 39.05H141.29V45.44H147.68V39.05Z",
    fill: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M160.46 39.05H154.07V45.44H160.46V39.05Z",
    fill: "black"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M173.24 39.05H166.85V45.44H173.24V39.05Z",
    fill: "black"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M179.63 39.05H173.24V45.44H179.63V39.05Z",
    fill: "black"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M186.02 39.05H179.63V45.44H186.02V39.05Z",
    fill: "black"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M198.8 39.05H192.41V45.44H198.8V39.05Z",
    fill: "black"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M19.88 45.4399H13.49V51.8299H19.88V45.4399Z",
    fill: "black"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M58.22 45.4399H51.83V51.8299H58.22V45.4399Z",
    fill: "black"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M71 45.4399H64.61V51.8299H71V45.4399Z",
    fill: "black"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M83.78 45.4399H77.39V51.8299H83.78V45.4399Z",
    fill: "black"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M109.34 45.4399H102.95V51.8299H109.34V45.4399Z",
    fill: "black"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M115.73 45.4399H109.34V51.8299H115.73V45.4399Z",
    fill: "black"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M134.9 45.4399H128.51V51.8299H134.9V45.4399Z",
    fill: "black"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M147.68 45.4399H141.29V51.8299H147.68V45.4399Z",
    fill: "black"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M160.46 45.4399H154.07V51.8299H160.46V45.4399Z",
    fill: "black"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M198.8 45.4399H192.41V51.8299H198.8V45.4399Z",
    fill: "black"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M19.88 51.83H13.49V58.22H19.88V51.83Z",
    fill: "black"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M26.27 51.83H19.88V58.22H26.27V51.83Z",
    fill: "black"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M32.66 51.83H26.27V58.22H32.66V51.83Z",
    fill: "black"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M39.05 51.83H32.66V58.22H39.05V51.83Z",
    fill: "black"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M45.44 51.83H39.05V58.22H45.44V51.83Z",
    fill: "black"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M51.83 51.83H45.44V58.22H51.83V51.83Z",
    fill: "black"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M58.22 51.83H51.83V58.22H58.22V51.83Z",
    fill: "black"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M71 51.83H64.61V58.22H71V51.83Z",
    fill: "black"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M83.78 51.83H77.39V58.22H83.78V51.83Z",
    fill: "black"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M96.56 51.83H90.17V58.22H96.56V51.83Z",
    fill: "black"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M109.34 51.83H102.95V58.22H109.34V51.83Z",
    fill: "black"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M122.12 51.83H115.73V58.22H122.12V51.83Z",
    fill: "black"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M134.9 51.83H128.51V58.22H134.9V51.83Z",
    fill: "black"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M147.68 51.83H141.29V58.22H147.68V51.83Z",
    fill: "black"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M160.46 51.83H154.07V58.22H160.46V51.83Z",
    fill: "black"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M166.85 51.83H160.46V58.22H166.85V51.83Z",
    fill: "black"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M173.24 51.83H166.85V58.22H173.24V51.83Z",
    fill: "black"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M179.63 51.83H173.24V58.22H179.63V51.83Z",
    fill: "black"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M186.02 51.83H179.63V58.22H186.02V51.83Z",
    fill: "black"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M192.41 51.83H186.02V58.22H192.41V51.83Z",
    fill: "black"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M198.8 51.83H192.41V58.22H198.8V51.83Z",
    fill: "black"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M90.17 58.22H83.78V64.61H90.17V58.22Z",
    fill: "black"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M109.34 58.22H102.95V64.61H109.34V58.22Z",
    fill: "black"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M141.29 58.22H134.9V64.61H141.29V58.22Z",
    fill: "black"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M147.68 58.22H141.29V64.61H147.68V58.22Z",
    fill: "black"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M19.88 64.61H13.49V71H19.88V64.61Z",
    fill: "black"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M26.27 64.61H19.88V71H26.27V64.61Z",
    fill: "black"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M32.66 64.61H26.27V71H32.66V64.61Z",
    fill: "black"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M39.05 64.61H32.66V71H39.05V64.61Z",
    fill: "black"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M45.44 64.61H39.05V71H45.44V64.61Z",
    fill: "black"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M58.22 64.61H51.83V71H58.22V64.61Z",
    fill: "black"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M64.61 64.61H58.22V71H64.61V64.61Z",
    fill: "black"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M71 64.61H64.61V71H71V64.61Z",
    fill: "black"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M77.39 64.61H71V71H77.39V64.61Z",
    fill: "black"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M83.78 64.61H77.39V71H83.78V64.61Z",
    fill: "black"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M102.95 64.61H96.56V71H102.95V64.61Z",
    fill: "black"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M115.73 64.61H109.34V71H115.73V64.61Z",
    fill: "black"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M122.12 64.61H115.73V71H122.12V64.61Z",
    fill: "black"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M128.51 64.61H122.12V71H128.51V64.61Z",
    fill: "black"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M141.29 64.61H134.9V71H141.29V64.61Z",
    fill: "black"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M154.07 64.61H147.68V71H154.07V64.61Z",
    fill: "black"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M166.85 64.61H160.46V71H166.85V64.61Z",
    fill: "black"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M179.63 64.61H173.24V71H179.63V64.61Z",
    fill: "black"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M192.41 64.61H186.02V71H192.41V64.61Z",
    fill: "black"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M19.88 71H13.49V77.39H19.88V71Z",
    fill: "black"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M26.27 71H19.88V77.39H26.27V71Z",
    fill: "black"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M32.66 71H26.27V77.39H32.66V71Z",
    fill: "black"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M51.83 71H45.44V77.39H51.83V71Z",
    fill: "black"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M64.61 71H58.22V77.39H64.61V71Z",
    fill: "black"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M71 71H64.61V77.39H71V71Z",
    fill: "black"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M77.39 71H71V77.39H77.39V71Z",
    fill: "black"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M90.17 71H83.78V77.39H90.17V71Z",
    fill: "black"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M96.56 71H90.17V77.39H96.56V71Z",
    fill: "black"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M102.95 71H96.56V77.39H102.95V71Z",
    fill: "black"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M122.12 71H115.73V77.39H122.12V71Z",
    fill: "black"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M128.51 71H122.12V77.39H128.51V71Z",
    fill: "black"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M134.9 71H128.51V77.39H134.9V71Z",
    fill: "black"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M141.29 71H134.9V77.39H141.29V71Z",
    fill: "black"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M147.68 71H141.29V77.39H147.68V71Z",
    fill: "black"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M154.07 71H147.68V77.39H154.07V71Z",
    fill: "black"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M160.46 71H154.07V77.39H160.46V71Z",
    fill: "black"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M173.24 71H166.85V77.39H173.24V71Z",
    fill: "black"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M198.8 71H192.41V77.39H198.8V71Z",
    fill: "black"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M19.88 77.39H13.49V83.78H19.88V77.39Z",
    fill: "black"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M39.05 77.39H32.66V83.78H39.05V77.39Z",
    fill: "black"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M58.22 77.39H51.83V83.78H58.22V77.39Z",
    fill: "black"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M71 77.39H64.61V83.78H71V77.39Z",
    fill: "black"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M77.39 77.39H71V83.78H77.39V77.39Z",
    fill: "black"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M96.56 77.39H90.17V83.78H96.56V77.39Z",
    fill: "black"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M102.95 77.39H96.56V83.78H102.95V77.39Z",
    fill: "black"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M109.34 77.39H102.95V83.78H109.34V77.39Z",
    fill: "black"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M115.73 77.39H109.34V83.78H115.73V77.39Z",
    fill: "black"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M128.51 77.39H122.12V83.78H128.51V77.39Z",
    fill: "black"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M147.68 77.39H141.29V83.78H147.68V77.39Z",
    fill: "black"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M160.46 77.39H154.07V83.78H160.46V77.39Z",
    fill: "black"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M166.85 77.39H160.46V83.78H166.85V77.39Z",
    fill: "black"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M19.88 83.78H13.49V90.17H19.88V83.78Z",
    fill: "black"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M32.66 83.78H26.27V90.17H32.66V83.78Z",
    fill: "black"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M45.44 83.78H39.05V90.17H45.44V83.78Z",
    fill: "black"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M64.61 83.78H58.22V90.17H64.61V83.78Z",
    fill: "black"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M71 83.78H64.61V90.17H71V83.78Z",
    fill: "black"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M77.39 83.78H71V90.17H77.39V83.78Z",
    fill: "black"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M83.78 83.78H77.39V90.17H83.78V83.78Z",
    fill: "black"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M96.56 83.78H90.17V90.17H96.56V83.78Z",
    fill: "black"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M109.34 83.78H102.95V90.17H109.34V83.78Z",
    fill: "black"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M115.73 83.78H109.34V90.17H115.73V83.78Z",
    fill: "black"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M134.9 83.78H128.51V90.17H134.9V83.78Z",
    fill: "black"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M141.29 83.78H134.9V90.17H141.29V83.78Z",
    fill: "black"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M154.07 83.78H147.68V90.17H154.07V83.78Z",
    fill: "black"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M160.46 83.78H154.07V90.17H160.46V83.78Z",
    fill: "black"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M173.24 83.78H166.85V90.17H173.24V83.78Z",
    fill: "black"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M179.63 83.78H173.24V90.17H179.63V83.78Z",
    fill: "black"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M192.41 83.78H186.02V90.17H192.41V83.78Z",
    fill: "black"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M58.22 90.17H51.83V96.5601H58.22V90.17Z",
    fill: "black"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M64.61 90.17H58.22V96.5601H64.61V90.17Z",
    fill: "black"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M71 90.17H64.61V96.5601H71V90.17Z",
    fill: "black"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M77.39 90.17H71V96.5601H77.39V90.17Z",
    fill: "black"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M102.95 90.17H96.56V96.5601H102.95V90.17Z",
    fill: "black"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M109.34 90.17H102.95V96.5601H109.34V90.17Z",
    fill: "black"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M115.73 90.17H109.34V96.5601H115.73V90.17Z",
    fill: "black"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M122.12 90.17H115.73V96.5601H122.12V90.17Z",
    fill: "black"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M128.51 90.17H122.12V96.5601H128.51V90.17Z",
    fill: "black"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M134.9 90.17H128.51V96.5601H134.9V90.17Z",
    fill: "black"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M166.85 90.17H160.46V96.5601H166.85V90.17Z",
    fill: "black"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M179.63 90.17H173.24V96.5601H179.63V90.17Z",
    fill: "black"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M186.02 90.17H179.63V96.5601H186.02V90.17Z",
    fill: "black"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M19.88 96.5601H13.49V102.95H19.88V96.5601Z",
    fill: "black"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M32.66 96.5601H26.27V102.95H32.66V96.5601Z",
    fill: "black"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M83.78 96.5601H77.39V102.95H83.78V96.5601Z",
    fill: "black"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M90.17 96.5601H83.78V102.95H90.17V96.5601Z",
    fill: "black"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M96.56 96.5601H90.17V102.95H96.56V96.5601Z",
    fill: "black"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M102.95 96.5601H96.56V102.95H102.95V96.5601Z",
    fill: "black"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M122.12 96.5601H115.73V102.95H122.12V96.5601Z",
    fill: "black"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M128.51 96.5601H122.12V102.95H128.51V96.5601Z",
    fill: "black"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M134.9 96.5601H128.51V102.95H134.9V96.5601Z",
    fill: "black"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M141.29 96.5601H134.9V102.95H141.29V96.5601Z",
    fill: "black"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M147.68 96.5601H141.29V102.95H147.68V96.5601Z",
    fill: "black"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M154.07 96.5601H147.68V102.95H154.07V96.5601Z",
    fill: "black"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M160.46 96.5601H154.07V102.95H160.46V96.5601Z",
    fill: "black"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M166.85 96.5601H160.46V102.95H166.85V96.5601Z",
    fill: "black"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M173.24 96.5601H166.85V102.95H173.24V96.5601Z",
    fill: "black"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M198.8 96.5601H192.41V102.95H198.8V96.5601Z",
    fill: "black"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M19.88 102.95H13.49V109.34H19.88V102.95Z",
    fill: "black"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M32.66 102.95H26.27V109.34H32.66V102.95Z",
    fill: "black"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M45.44 102.95H39.05V109.34H45.44V102.95Z",
    fill: "black"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M58.22 102.95H51.83V109.34H58.22V102.95Z",
    fill: "black"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M64.61 102.95H58.22V109.34H64.61V102.95Z",
    fill: "black"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M77.39 102.95H71V109.34H77.39V102.95Z",
    fill: "black"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M83.78 102.95H77.39V109.34H83.78V102.95Z",
    fill: "black"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M96.56 102.95H90.17V109.34H96.56V102.95Z",
    fill: "black"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M115.73 102.95H109.34V109.34H115.73V102.95Z",
    fill: "black"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M122.12 102.95H115.73V109.34H122.12V102.95Z",
    fill: "black"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M128.51 102.95H122.12V109.34H128.51V102.95Z",
    fill: "black"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M154.07 102.95H147.68V109.34H154.07V102.95Z",
    fill: "black"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M173.24 102.95H166.85V109.34H173.24V102.95Z",
    fill: "black"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M179.63 102.95H173.24V109.34H179.63V102.95Z",
    fill: "black"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M186.02 102.95H179.63V109.34H186.02V102.95Z",
    fill: "black"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M19.88 109.34H13.49V115.73H19.88V109.34Z",
    fill: "black"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M32.66 109.34H26.27V115.73H32.66V109.34Z",
    fill: "black"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M51.83 109.34H45.44V115.73H51.83V109.34Z",
    fill: "black"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M64.61 109.34H58.22V115.73H64.61V109.34Z",
    fill: "black"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M83.78 109.34H77.39V115.73H83.78V109.34Z",
    fill: "black"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M90.17 109.34H83.78V115.73H90.17V109.34Z",
    fill: "black"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M96.56 109.34H90.17V115.73H96.56V109.34Z",
    fill: "black"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M109.34 109.34H102.95V115.73H109.34V109.34Z",
    fill: "black"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M122.12 109.34H115.73V115.73H122.12V109.34Z",
    fill: "black"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M141.29 109.34H134.9V115.73H141.29V109.34Z",
    fill: "black"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M147.68 109.34H141.29V115.73H147.68V109.34Z",
    fill: "black"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M173.24 109.34H166.85V115.73H173.24V109.34Z",
    fill: "black"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M192.41 109.34H186.02V115.73H192.41V109.34Z",
    fill: "black"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M26.27 115.73H19.88V122.12H26.27V115.73Z",
    fill: "black"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M39.05 115.73H32.66V122.12H39.05V115.73Z",
    fill: "black"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M51.83 115.73H45.44V122.12H51.83V115.73Z",
    fill: "black"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M58.22 115.73H51.83V122.12H58.22V115.73Z",
    fill: "black"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M64.61 115.73H58.22V122.12H64.61V115.73Z",
    fill: "black"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M77.39 115.73H71V122.12H77.39V115.73Z",
    fill: "black"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M102.95 115.73H96.56V122.12H102.95V115.73Z",
    fill: "black"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M109.34 115.73H102.95V122.12H109.34V115.73Z",
    fill: "black"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M128.51 115.73H122.12V122.12H128.51V115.73Z",
    fill: "black"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M141.29 115.73H134.9V122.12H141.29V115.73Z",
    fill: "black"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M166.85 115.73H160.46V122.12H166.85V115.73Z",
    fill: "black"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M179.63 115.73H173.24V122.12H179.63V115.73Z",
    fill: "black"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M186.02 115.73H179.63V122.12H186.02V115.73Z",
    fill: "black"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M19.88 122.12H13.49V128.51H19.88V122.12Z",
    fill: "black"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M39.05 122.12H32.66V128.51H39.05V122.12Z",
    fill: "black"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M45.44 122.12H39.05V128.51H45.44V122.12Z",
    fill: "black"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M64.61 122.12H58.22V128.51H64.61V122.12Z",
    fill: "black"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M77.39 122.12H71V128.51H77.39V122.12Z",
    fill: "black"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M83.78 122.12H77.39V128.51H83.78V122.12Z",
    fill: "black"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M90.17 122.12H83.78V128.51H90.17V122.12Z",
    fill: "black"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M96.56 122.12H90.17V128.51H96.56V122.12Z",
    fill: "black"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M122.12 122.12H115.73V128.51H122.12V122.12Z",
    fill: "black"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M134.9 122.12H128.51V128.51H134.9V122.12Z",
    fill: "black"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M141.29 122.12H134.9V128.51H141.29V122.12Z",
    fill: "black"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M160.46 122.12H154.07V128.51H160.46V122.12Z",
    fill: "black"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M166.85 122.12H160.46V128.51H166.85V122.12Z",
    fill: "black"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M173.24 122.12H166.85V128.51H173.24V122.12Z",
    fill: "black"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M186.02 122.12H179.63V128.51H186.02V122.12Z",
    fill: "black"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M198.8 122.12H192.41V128.51H198.8V122.12Z",
    fill: "black"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M19.88 128.51H13.49V134.9H19.88V128.51Z",
    fill: "black"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M39.05 128.51H32.66V134.9H39.05V128.51Z",
    fill: "black"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M58.22 128.51H51.83V134.9H58.22V128.51Z",
    fill: "black"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M64.61 128.51H58.22V134.9H64.61V128.51Z",
    fill: "black"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M96.56 128.51H90.17V134.9H96.56V128.51Z",
    fill: "black"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M109.34 128.51H102.95V134.9H109.34V128.51Z",
    fill: "black"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M115.73 128.51H109.34V134.9H115.73V128.51Z",
    fill: "black"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M122.12 128.51H115.73V134.9H122.12V128.51Z",
    fill: "black"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M134.9 128.51H128.51V134.9H134.9V128.51Z",
    fill: "black"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M147.68 128.51H141.29V134.9H147.68V128.51Z",
    fill: "black"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M154.07 128.51H147.68V134.9H154.07V128.51Z",
    fill: "black"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M173.24 128.51H166.85V134.9H173.24V128.51Z",
    fill: "black"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M186.02 128.51H179.63V134.9H186.02V128.51Z",
    fill: "black"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M19.88 134.9H13.49V141.29H19.88V134.9Z",
    fill: "black"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M32.66 134.9H26.27V141.29H32.66V134.9Z",
    fill: "black"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M45.44 134.9H39.05V141.29H45.44V134.9Z",
    fill: "black"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M51.83 134.9H45.44V141.29H51.83V134.9Z",
    fill: "black"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M64.61 134.9H58.22V141.29H64.61V134.9Z",
    fill: "black"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M83.78 134.9H77.39V141.29H83.78V134.9Z",
    fill: "black"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M115.73 134.9H109.34V141.29H115.73V134.9Z",
    fill: "black"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M122.12 134.9H115.73V141.29H122.12V134.9Z",
    fill: "black"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M147.68 134.9H141.29V141.29H147.68V134.9Z",
    fill: "black"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M154.07 134.9H147.68V141.29H154.07V134.9Z",
    fill: "black"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M173.24 134.9H166.85V141.29H173.24V134.9Z",
    fill: "black"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M192.41 134.9H186.02V141.29H192.41V134.9Z",
    fill: "black"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M19.88 141.29H13.49V147.68H19.88V141.29Z",
    fill: "black"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M32.66 141.29H26.27V147.68H32.66V141.29Z",
    fill: "black"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M39.05 141.29H32.66V147.68H39.05V141.29Z",
    fill: "black"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M58.22 141.29H51.83V147.68H58.22V141.29Z",
    fill: "black"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M64.61 141.29H58.22V147.68H64.61V141.29Z",
    fill: "black"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M71 141.29H64.61V147.68H71V141.29Z",
    fill: "black"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M77.39 141.29H71V147.68H77.39V141.29Z",
    fill: "black"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M102.95 141.29H96.56V147.68H102.95V141.29Z",
    fill: "black"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M115.73 141.29H109.34V147.68H115.73V141.29Z",
    fill: "black"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M128.51 141.29H122.12V147.68H128.51V141.29Z",
    fill: "black"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M147.68 141.29H141.29V147.68H147.68V141.29Z",
    fill: "black"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M154.07 141.29H147.68V147.68H154.07V141.29Z",
    fill: "black"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M160.46 141.29H154.07V147.68H160.46V141.29Z",
    fill: "black"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M166.85 141.29H160.46V147.68H166.85V141.29Z",
    fill: "black"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M173.24 141.29H166.85V147.68H173.24V141.29Z",
    fill: "black"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M186.02 141.29H179.63V147.68H186.02V141.29Z",
    fill: "black"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M192.41 141.29H186.02V147.68H192.41V141.29Z",
    fill: "black"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M198.8 141.29H192.41V147.68H198.8V141.29Z",
    fill: "black"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M71 147.68H64.61V154.07H71V147.68Z",
    fill: "black"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M83.78 147.68H77.39V154.07H83.78V147.68Z",
    fill: "black"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M90.17 147.68H83.78V154.07H90.17V147.68Z",
    fill: "black"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M96.56 147.68H90.17V154.07H96.56V147.68Z",
    fill: "black"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M109.34 147.68H102.95V154.07H109.34V147.68Z",
    fill: "black"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M122.12 147.68H115.73V154.07H122.12V147.68Z",
    fill: "black"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M147.68 147.68H141.29V154.07H147.68V147.68Z",
    fill: "black"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M173.24 147.68H166.85V154.07H173.24V147.68Z",
    fill: "black"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M179.63 147.68H173.24V154.07H179.63V147.68Z",
    fill: "black"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M186.02 147.68H179.63V154.07H186.02V147.68Z",
    fill: "black"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M192.41 147.68H186.02V154.07H192.41V147.68Z",
    fill: "black"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M198.8 147.68H192.41V154.07H198.8V147.68Z",
    fill: "black"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M19.88 154.07H13.49V160.46H19.88V154.07Z",
    fill: "black"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M26.27 154.07H19.88V160.46H26.27V154.07Z",
    fill: "black"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M32.66 154.07H26.27V160.46H32.66V154.07Z",
    fill: "black"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M39.05 154.07H32.66V160.46H39.05V154.07Z",
    fill: "black"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M45.44 154.07H39.05V160.46H45.44V154.07Z",
    fill: "black"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M51.83 154.07H45.44V160.46H51.83V154.07Z",
    fill: "black"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M58.22 154.07H51.83V160.46H58.22V154.07Z",
    fill: "black"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M71 154.07H64.61V160.46H71V154.07Z",
    fill: "black"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M77.39 154.07H71V160.46H77.39V154.07Z",
    fill: "black"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M83.78 154.07H77.39V160.46H83.78V154.07Z",
    fill: "black"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M115.73 154.07H109.34V160.46H115.73V154.07Z",
    fill: "black"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M134.9 154.07H128.51V160.46H134.9V154.07Z",
    fill: "black"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M141.29 154.07H134.9V160.46H141.29V154.07Z",
    fill: "black"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M147.68 154.07H141.29V160.46H147.68V154.07Z",
    fill: "black"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M160.46 154.07H154.07V160.46H160.46V154.07Z",
    fill: "black"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M173.24 154.07H166.85V160.46H173.24V154.07Z",
    fill: "black"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M179.63 154.07H173.24V160.46H179.63V154.07Z",
    fill: "black"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M186.02 154.07H179.63V160.46H186.02V154.07Z",
    fill: "black"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M19.88 160.46H13.49V166.85H19.88V160.46Z",
    fill: "black"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M58.22 160.46H51.83V166.85H58.22V160.46Z",
    fill: "black"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M77.39 160.46H71V166.85H77.39V160.46Z",
    fill: "black"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M83.78 160.46H77.39V166.85H83.78V160.46Z",
    fill: "black"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M90.17 160.46H83.78V166.85H90.17V160.46Z",
    fill: "black"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M96.56 160.46H90.17V166.85H96.56V160.46Z",
    fill: "black"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M109.34 160.46H102.95V166.85H109.34V160.46Z",
    fill: "black"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M115.73 160.46H109.34V166.85H115.73V160.46Z",
    fill: "black"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M122.12 160.46H115.73V166.85H122.12V160.46Z",
    fill: "black"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M134.9 160.46H128.51V166.85H134.9V160.46Z",
    fill: "black"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M141.29 160.46H134.9V166.85H141.29V160.46Z",
    fill: "black"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M147.68 160.46H141.29V166.85H147.68V160.46Z",
    fill: "black"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M173.24 160.46H166.85V166.85H173.24V160.46Z",
    fill: "black"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M198.8 160.46H192.41V166.85H198.8V160.46Z",
    fill: "black"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M19.88 166.85H13.49V173.24H19.88V166.85Z",
    fill: "black"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M32.66 166.85H26.27V173.24H32.66V166.85Z",
    fill: "black"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M39.05 166.85H32.66V173.24H39.05V166.85Z",
    fill: "black"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M45.44 166.85H39.05V173.24H45.44V166.85Z",
    fill: "black"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M58.22 166.85H51.83V173.24H58.22V166.85Z",
    fill: "black"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M71 166.85H64.61V173.24H71V166.85Z",
    fill: "black"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M77.39 166.85H71V173.24H77.39V166.85Z",
    fill: "black"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M102.95 166.85H96.56V173.24H102.95V166.85Z",
    fill: "black"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M128.51 166.85H122.12V173.24H128.51V166.85Z",
    fill: "black"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M147.68 166.85H141.29V173.24H147.68V166.85Z",
    fill: "black"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M154.07 166.85H147.68V173.24H154.07V166.85Z",
    fill: "black"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M160.46 166.85H154.07V173.24H160.46V166.85Z",
    fill: "black"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M166.85 166.85H160.46V173.24H166.85V166.85Z",
    fill: "black"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M173.24 166.85H166.85V173.24H173.24V166.85Z",
    fill: "black"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M186.02 166.85H179.63V173.24H186.02V166.85Z",
    fill: "black"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M192.41 166.85H186.02V173.24H192.41V166.85Z",
    fill: "black"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M19.88 173.24H13.49V179.63H19.88V173.24Z",
    fill: "black"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M32.66 173.24H26.27V179.63H32.66V173.24Z",
    fill: "black"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M39.05 173.24H32.66V179.63H39.05V173.24Z",
    fill: "black"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M45.44 173.24H39.05V179.63H45.44V173.24Z",
    fill: "black"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M58.22 173.24H51.83V179.63H58.22V173.24Z",
    fill: "black"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M71 173.24H64.61V179.63H71V173.24Z",
    fill: "black"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M83.78 173.24H77.39V179.63H83.78V173.24Z",
    fill: "black"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M90.17 173.24H83.78V179.63H90.17V173.24Z",
    fill: "black"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M96.56 173.24H90.17V179.63H96.56V173.24Z",
    fill: "black"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M109.34 173.24H102.95V179.63H109.34V173.24Z",
    fill: "black"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M122.12 173.24H115.73V179.63H122.12V173.24Z",
    fill: "black"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M166.85 173.24H160.46V179.63H166.85V173.24Z",
    fill: "black"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M179.63 173.24H173.24V179.63H179.63V173.24Z",
    fill: "black"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M186.02 173.24H179.63V179.63H186.02V173.24Z",
    fill: "black"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M198.8 173.24H192.41V179.63H198.8V173.24Z",
    fill: "black"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M19.88 179.63H13.49V186.02H19.88V179.63Z",
    fill: "black"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M32.66 179.63H26.27V186.02H32.66V179.63Z",
    fill: "black"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M39.05 179.63H32.66V186.02H39.05V179.63Z",
    fill: "black"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M45.44 179.63H39.05V186.02H45.44V179.63Z",
    fill: "black"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M58.22 179.63H51.83V186.02H58.22V179.63Z",
    fill: "black"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M71 179.63H64.61V186.02H71V179.63Z",
    fill: "black"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M77.39 179.63H71V186.02H77.39V179.63Z",
    fill: "black"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M96.56 179.63H90.17V186.02H96.56V179.63Z",
    fill: "black"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M109.34 179.63H102.95V186.02H109.34V179.63Z",
    fill: "black"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M115.73 179.63H109.34V186.02H115.73V179.63Z",
    fill: "black"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M122.12 179.63H115.73V186.02H122.12V179.63Z",
    fill: "black"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M134.9 179.63H128.51V186.02H134.9V179.63Z",
    fill: "black"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M141.29 179.63H134.9V186.02H141.29V179.63Z",
    fill: "black"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M147.68 179.63H141.29V186.02H147.68V179.63Z",
    fill: "black"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M160.46 179.63H154.07V186.02H160.46V179.63Z",
    fill: "black"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M166.85 179.63H160.46V186.02H166.85V179.63Z",
    fill: "black"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M173.24 179.63H166.85V186.02H173.24V179.63Z",
    fill: "black"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M179.63 179.63H173.24V186.02H179.63V179.63Z",
    fill: "black"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M186.02 179.63H179.63V186.02H186.02V179.63Z",
    fill: "black"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M192.41 179.63H186.02V186.02H192.41V179.63Z",
    fill: "black"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M19.88 186.02H13.49V192.41H19.88V186.02Z",
    fill: "black"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M58.22 186.02H51.83V192.41H58.22V186.02Z",
    fill: "black"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M71 186.02H64.61V192.41H71V186.02Z",
    fill: "black"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M77.39 186.02H71V192.41H77.39V186.02Z",
    fill: "black"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M109.34 186.02H102.95V192.41H109.34V186.02Z",
    fill: "black"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M122.12 186.02H115.73V192.41H122.12V186.02Z",
    fill: "black"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M134.9 186.02H128.51V192.41H134.9V186.02Z",
    fill: "black"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M147.68 186.02H141.29V192.41H147.68V186.02Z",
    fill: "black"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M154.07 186.02H147.68V192.41H154.07V186.02Z",
    fill: "black"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M166.85 186.02H160.46V192.41H166.85V186.02Z",
    fill: "black"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M173.24 186.02H166.85V192.41H173.24V186.02Z",
    fill: "black"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M179.63 186.02H173.24V192.41H179.63V186.02Z",
    fill: "black"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M192.41 186.02H186.02V192.41H192.41V186.02Z",
    fill: "black"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M19.88 192.41H13.49V198.8H19.88V192.41Z",
    fill: "black"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M26.27 192.41H19.88V198.8H26.27V192.41Z",
    fill: "black"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M32.66 192.41H26.27V198.8H32.66V192.41Z",
    fill: "black"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M39.05 192.41H32.66V198.8H39.05V192.41Z",
    fill: "black"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M45.44 192.41H39.05V198.8H45.44V192.41Z",
    fill: "black"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M51.83 192.41H45.44V198.8H51.83V192.41Z",
    fill: "black"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M58.22 192.41H51.83V198.8H58.22V192.41Z",
    fill: "black"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M71 192.41H64.61V198.8H71V192.41Z",
    fill: "black"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M77.39 192.41H71V198.8H77.39V192.41Z",
    fill: "black"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M102.95 192.41H96.56V198.8H102.95V192.41Z",
    fill: "black"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M128.51 192.41H122.12V198.8H128.51V192.41Z",
    fill: "black"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M134.9 192.41H128.51V198.8H134.9V192.41Z",
    fill: "black"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M141.29 192.41H134.9V198.8H141.29V192.41Z",
    fill: "black"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M154.07 192.41H147.68V198.8H154.07V192.41Z",
    fill: "black"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M173.24 192.41H166.85V198.8H173.24V192.41Z",
    fill: "black"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M186.02 192.41H179.63V198.8H186.02V192.41Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 195,
    height: 56,
    fill: "white",
    transform: "translate(9 219)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStoreQrcode);
export default __webpack_public_path__ + "static/media/app-store-qrcode.b5792422ecf297511b87e22c0026c994.svg";
export { ForwardRef as ReactComponent };